import React from 'react';
import { Card, CardContent } from '@mui/material';
import ProgressBar from 'Components/ProgressBar';
import { cardContent, CardIcon, CardInfo, BadgeTitle, BadgeDescription } from './style';

function BadgeCard({ userAchievement, achievement }) {
  return (
    <Card sx={{ display: 'flex', flexDirection: 'row', width: 600, height: 160 }}>
      <CardContent style={cardContent}>
        <CardIcon>
          <div style={{ height: '70%', width: '70%' }}>
            <img
              style={{ maxHeight: '100%', maxWidth: '100%' }}
              src={userAchievement.completed ? achievement.completedIcon : achievement.uncompletedIcon}
            />
          </div>
        </CardIcon>
        <CardInfo>
          <BadgeTitle>{achievement.name}</BadgeTitle>
          <BadgeDescription>{achievement.description}</BadgeDescription>
          <ProgressBar value={userAchievement.progress} />
        </CardInfo>
      </CardContent>
    </Card>
  );
}

export default BadgeCard;
